<template>
    <div class="vsl-row vsl-image-gallery-row">
        <div id="vslImageCarousel" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div v-bind:class="carouselItemClass(imageUrl)" v-for="imageUrl of imagesUrls" v-bind:key="imageUrl">
                    <div class="vsl-image-gallery-row-item">
                        <img v-bind:src="imageUrl" class="d-block w-100" />
                    </div>
                </div>
            </div>
            <button v-if="imagesUrls.length > 1" class="btn btn-link carousel-control-prev" type="button" data-bs-target="#vslImageCarousel" data-bs-slide="prev">
                <img src="@/assets/buttons/ImageGalleryPreviousIcon.png" />
                <span class="visually-hidden">Previous</span>
            </button>
            <button v-if="imagesUrls.length > 1" class="btn carousel-control-next" type="button" data-bs-target="#vslImageCarousel" data-bs-slide="next">
                <img src="@/assets/buttons/ImageGalleryNextIcon.png" />
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        imagesUrls: null
    },

    methods: {
        carouselItemClass(imageUrl) {
            return this.imagesUrls && this.imagesUrls.indexOf(imageUrl) == 0 ? "vsl-image-gallery-row-item carousel-item active" : "vsl-image-gallery-row-item carousel-item";
        }
    }
}
</script>

<style scoped>
.vsl-image-gallery-row {
    padding-left: 0px !important;
    padding-right: 0px !important;
    height: 300px;
    vertical-align: middle;
}

.vsl-image-gallery-row-item img {
    height: 300px;
    object-fit: contain;
}

.vsl-image-gallery-row button {
    border: none;
    box-shadow: none;
}

.vsl-image-gallery-row button:hover {
    border: none;
    box-shadow: none;
}

.vsl-image-gallery-row button img {
    width: 45px;
}
</style>
